import { useState, useEffect } from "react";

export const useBinaryStateMachine = ({ ambientState }) => {
  const [state, setState] = useState(ambientState);

  useEffect(() => {
    if (!ambientState) {
      setState(false);
    }
  }, [ambientState]);

  return [state, () => setState(true)];
};
